import { inject, Injectable } from '@angular/core';
import { MailTemplateIds, SimulateRecipientsResponse } from '@monorepo/interfaces';
import { OrganisationCommunicationType } from '@shared/enums/OrganisationCommunicationType';
import { ApiService } from '@shared/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class MailingService {
    private readonly apiUrl = '/mailing';

    private readonly apiService = inject(ApiService);

    public async sendToResponsible(reportId: string) {
        return await this.apiService.post(`${this.apiUrl}/responsibles`, {
            reportId
        });
    }

    public async simulateRecipients(
        orgId: string,
        communicationType: OrganisationCommunicationType
    ): Promise<SimulateRecipientsResponse[]> {
        return await this.apiService.get(`${this.apiUrl}/${orgId}/simulate-recipients/${communicationType}`);
    }

    public async getTemplateIds(): Promise<MailTemplateIds> {
        return await this.apiService.get(`${this.apiUrl}/template-ids`);
    }
}
